<template>
  <div class="addBox relative">
    <div class="title">
      <div class="title_left">
        <span class="movePoin" @click="$router.go(-1)">{{name}}</span>/<span class="type">详情</span>
      </div>
    </div>
    <el-form :model="fillFormDto" ref="fillFormDto" label-width="150px">
      <ToggleForm title="基本信息">
        <div class="content">
          <div class="row mt20">
            <el-form-item label="供应商名称：" prop="supplyId">
              {{fillFormDto.supplyName}}
            </el-form-item>
          </div>
          <div class="row dbBox">
            <el-form-item label="所在区域：" prop="sourceEntityId">{{fillFormDto.supplyAreaName}}</el-form-item>
            <el-form-item label="经营地址：" prop="sourceEntityId">{{fillFormDto.supplyAddr}}</el-form-item>
          </div>
          <div class="row dbBox">
            <el-form-item label="法人/负责人：" prop="sourceEntityId">{{fillFormDto.supplyLegalPerson}}</el-form-item>
            <el-form-item label="联系方式：" prop="sourceEntityId">{{fillFormDto.supplyTel}}</el-form-item>
          </div>
          <div class="row">
            <el-form-item label="来源名称：" prop="buyPerson">{{fillFormDto.sourceEntityName}}</el-form-item>
          </div>
          <div class="row">
            <el-form-item label="采购人：" prop="buyDate">{{fillFormDto.buyPerson}}</el-form-item>
          </div>
          <div class="row">
            <el-form-item label="采购时间：" prop="buyDate">{{fillFormDto.buyDate}}</el-form-item>
          </div>
        </div>
      </ToggleForm>
      <ToggleForm title="商品信息">
        <div class="content">
          <el-tabs v-model="activeName">
            <el-tab-pane name="ybz">
              <span slot="label" class="tabLab">预包装食品填报</span>
              <el-table :data="queryLimit.preTabData" style="width: 100%;margin-top: 5px;">
                <el-table-column prop="" min-width="20" label=""></el-table-column><!-- 占位 -->
                <el-table-column min-width="120" label="商品名称" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="margin-10">
                      <span>{{scope.row.goodName}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="140" label="采购量" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="margin-10">
                      <span>{{scope.row.buyQuantity}}{{scope.row.buyQuantityUnit}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="140" label="商品单价" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="margin-10">
                      <span>{{scope.row.price}}{{scope.row.priceUnit}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="150" label="生产日期" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="margin-10">
                      <span>{{scope.row.productionDate}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="150" label="有效期至" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="margin-10">
                      <span>{{scope.row.effectiveDate}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="170" label="生产厂商" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="margin-10">
                      <span>{{scope.row.productVendor}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="170" label="厂商地址" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="margin-10">
                      <span>{{scope.row.productVendorAddr}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="150" label="生产批次号" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="margin-10">
                      <span>{{scope.row.productBatchNo}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="100" label="凭证" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="pinzheng_span" v-if="scope.row.voucherUrl.animalVoucherList||scope.row.voucherUrl.otherVoucherList||scope.row.voucherUrl.tranVoucherList" @click="previewImg(scope.row.voucherUrl)">查看凭证</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination-box mt20 textR">
                <el-pagination background @size-change="prepageSizeChange" @current-change="prepageCurrentChange"
                  :current-page="queryLimit.prepageNum" :page-sizes="[10, 20, 30, 40,50]" :page-size="queryLimit.prepageSize"
                  layout="total,prev, pager, next, sizes, jumper" :total="queryLimit.pretotal">
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane name="fybz">
              <span slot="label" class="tabLab">非预包装食品填报</span>
              <el-table :data="queryLimit.disTabData" style="width: 100%;margin-top: 5px;">
                <el-table-column prop="" min-width="20" label=""></el-table-column><!-- 占位 -->
                <el-table-column min-width="210" label="商品名称" prop="goodName">
                  <template slot-scope="scope">
                    <div class="margin-10">
                      <span>{{scope.row.goodName}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="160" label="采购量" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="margin-10">
                      {{scope.row.buyQuantity}}{{scope.row.buyQuantityUnit}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="160" label="商品单价" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="margin-10">
                      {{scope.row.price}}{{scope.row.priceUnit}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="100" label="凭证" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="pinzheng_span" v-if="scope.row.voucherUrl.animalVoucherList||scope.row.voucherUrl.otherVoucherList||scope.row.voucherUrl.tranVoucherList"
                         @click="previewImg(scope.row.voucherUrl)">查看凭证</span>
                    <span class="pinzheng_span" v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination-box mt20 textR">
                <el-pagination background @size-change="dispageSizeChange" @current-change="dispageCurrentChange"
                  :current-page="queryLimit.dispageNum" :page-sizes="[10, 20, 30, 40,50]" :page-size="queryLimit.dispageSize"
                  layout="total,prev, pager, next, sizes, jumper" :total="queryLimit.distotal">
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </ToggleForm>
    </el-form>
    <div class="foot-btn">
      <div>
        <el-button class="w70 mr10" @click="$router.go(-1)">返回</el-button>
        <el-button calss="w70" @click="openEdit">编辑</el-button>
      </div>
    </div>
    <Preview :showImg="PreviewShow" @close="PreviewShow = false" :currentIndex='PreviewIndex' :title='PreviewTitle'
      :imgList="PreviewFileList"></Preview>
  </div>
</template>

<script>
import ToggleForm from "components/ToggleForm";
import * as api from "api/report";
import Preview from 'components/previewImg';
export default {
  name: "personAdd",
  components: { 
      ToggleForm,
      Preview
  },
  data() {
    return {
      id: '',
      activeName: 'ybz',
      fillFormDto: {},
      baseUrl: this.$store.state.common.baseUrl,
      PreviewShow: false,
      PreviewFileList: [],
      PreviewTitle: '凭证',
      PreviewIndex: 1,
      queryLimit: {
        dispageNum: 1,
        dispageSize: 10,
        distotal: 0,
        disTabData: [],
        prepageNum: 1,
        prepageSize: 10,
        pretotal: 0,
        preTabData: []
      },
      name:'商品填报'
    };
  },
  methods: {
    disPage(){
      let _data = {
        id: this.id,
        pageNum: this.queryLimit.dispageNum,
        pageSize: this.queryLimit.dispageSize
      }
      api.fillDetailDispackage(_data).then(r=>{
        if(r.code){
          this.queryLimit.distotal = r.data.total;
          this.queryLimit.disTabData = r.data.records;
        }
      })
    },
    dispageSizeChange(size){
      this.queryLimit.dispageSize = size;
      this.disPage();
    },
    dispageCurrentChange(num){
      this.queryLimit.dispageNum = num;
      this.disPage();
    }, 
    prePage() {
      let _data = {
        id: this.id,
        pageNum: this.queryLimit.prepageNum,
        pageSize: this.queryLimit.prepageSize
      }
      api.fillDetailPackage(_data).then(r => {
        if (r.code) {
          this.queryLimit.pretotal = r.data.total;
          this.queryLimit.preTabData = r.data.records;
        }
      })
    },
    prepageSizeChange(size) {
      this.queryLimit.prepageSize = size;
      this.prePage();
    },
    prepageCurrentChange(num) {
      this.queryLimit.prepageNum = num;
      this.prePage();
    },
    openEdit(row) {
      this.$router.push({ name: 'sourceFill.goodsFillAdd', query: { type: 'edit', id: this.id } })
    },
    initEditData() {
      api.goodsFillDetail({id: this.$route.query.id}).then(r=>{
        if(r.code == 200){
          this.fillFormDto = r.data;
        }
      })
    },
    previewImg(imgList) {
      this.PreviewFileList = [];
      for(let item in imgList) {
        if (imgList[item]) {
          this.PreviewFileList.push(this.baseUrl + '/' + imgList[item][0].fileUrl)
        }
      }
      this.PreviewShow = true;
    }
  },
  mounted() {
    this.id = this.$route.query.id ? this.$route.query.id : "";
    this.name=this.$route.query.name;
    this.initEditData();
    this.disPage();
    this.prePage();
  },
};
</script>

<style scoped lang='scss'>
.addBox {
  width: calc(100% - 40px);
  min-height: calc(100% - 100px);
  padding: 0 20px 100px 20px;
  .title {
    height: 60px;
    line-height: 60px;
    .title_left {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 50%;
      height: 100%;
      .type {
        color: #70ce97;
      }
    }
  }
  .content{
    padding: 0 30px;
    .tabLab{
      width: 180px;
      display: block;
      text-align: center;
    }
  }
}
.dbBox{
  display: flex;
  .el-form-item {
    width: 45%;
    min-width: 400px;
  }
}
.margin-10{
  margin-left: -10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.w80{
  width: 80px;
}
.w140{
  width: 140px;
}
.pinzheng_span{
  font-size: 14px;
  color: #70CE97;
  cursor: pointer;
}
</style>